
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import AppMenu from "./components/AppMenu.vue";
import { TenantResource } from "@/api/requests/tenant/types";

@Component<App>({
  components: { AppMenu },
  metaInfo() {
    const title = this.title;
    const faviconPath = this.faviconPath;
    return {
      title,
      link: [{ rel: "icon", href: faviconPath }],
    };
  },
})
export default class App extends Vue {
  @State appLoaded!: boolean;
  @State tenant!: TenantResource;

  private get title(): string {
    // recupera il nome del tenant, rendendo maiuscola la prima lettera
    return this.tenant && this.tenant.slug
      ? this.tenant.slug.replace(/^\w/, (c) => c.toUpperCase())
      : "Manute";
  }

  private get faviconPath(): string {
    return this.tenant && this.tenant.faviconUrl
      ? this.tenant.faviconUrl
      : "favicon.ico";
  }

  created(){
    //@ts-ignore
    this.$history.clear();
  }
}
